import { combineReducers } from 'redux';

import MonthlyExport from './monthlyexport/reducer';

export default combineReducers({
  MonthlyExport,
});



// WEBPACK FOOTER //
// ./src/pages/genericexport/state/reducer.js